import { EmptyComponent } from "../../common/EmptyComponent";
import Loadable from "react-loadable";

export const BiometricsOldChunk = Loadable({
  loader: () =>
    import(/* webpackChunkName: "biometrics/legacy" */ "./Biometrics.old"),
  loading: EmptyComponent
});
